<div class="back-to-home rounded d-none d-sm-block">
  <a routerLink="/index" class="btn btn-icon btn-soft-primary">
    <i-feather name="home" class="icons"></i-feather>
  </a>
</div>

<!-- ERROR PAGE -->
<section class="bg-home d-flex align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-12 text-center">
        <img src="assets/images/404.svg" class="img-fluid" alt="">
        <div class="mt-4 display-3">Ουπς...</div>
        <div class="text-capitalize text-dark mb-4 error-page">Η σελίδα δεν βρέθηκε!</div>
        <p class="text-muted para-desc mx-auto">Μάλλον αυτό που ψάχνετε δεν υπάρχει!</p>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <div class="row">
      <div class="col-md-12 text-center">
        <a (click)="goBack()" class="btn btn-outline-primary mt-4">Πίσω</a>
        <a routerLink="/index" class="btn btn-primary mt-4 ms-2">Αρχική</a>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- ERROR PAGE -->